export const CURRENT_RELEASE = 2;

const MINUTES_FOR_GAME = 3;
export const MIND_THE_GAP_TIME_LIMIT = (1000 * 60 * MINUTES_FOR_GAME);

export const GAME_ID = 'mind_the_gap';

export const SCREENS = {
  ACTIVITY: 'activity',
  LOADING: 'loading',
  PROGRESS_SCREEN: 'progress_screen',
};

// action types
export const ACTION_TYPES = {
  ENABLE_USER_RESPONSES: 'ENABLE_USER_RESPONSES',
  DISABLE_USER_RESPONSES: 'DISABLE_USER_RESPONSES',
  SELECT_AN_ANSWER: 'SELECT_AN_ANSWER',
  SET_FIRST_PLACEHOLDER: 'SET_FIRST_PLACEHOLDER',
  LOAD_SAVED_DATA: 'LOAD_SAVED_DATA',
  SAVE_PROGRESS_LOCALLY: 'SAVE_PROGRESS_LOCALLY',
  SET_PREVIOUS_SESSION_TIME: 'SET_PREVIOUS_SESSION_TIME',
  SET_SELECTED_PLACEHOLDER: 'SET_SELECTED_PLACEHOLDER',
  SET_ALEX_SPEAKING: 'SET_ALEX_SPEAKING',
  SET_ALEX_INACTIVE: 'SET_ALEX_INACTIVE',
  INIT_SESSION: 'INIT_SESSION',
  START_STANDARD_MODE: 'START_STANDARD_MODE',
  SET_ANSWERS_MAP: 'SET_ANSWERS_MAP',
};

export const KEYCODE = {
  RETURN: 13,
  SPACE: 32,
  END: 35,
  HOME: 36,
  LEFT: 37,
  UP: 38,
  RIGHT: 39,
  DOWN: 40,
  ESCAPE: 27,
};
